import { axios } from 'lib/axios';
import { useQuery } from 'react-query';

export const getNotifications = () => {
  return axios.get('/portfolio/notifications/active_list');
};

export const useNotifications = ({ config } = {}) => {
  return useQuery({
    ...config,
    queryKey: ['notifications'],
    queryFn: () => getNotifications(),
  });
};
